import React, {useContext} from "react";
import "./WhatsAppFAB.css";
import wapp_icon2 from "../../../assets/images/whatsapp_icon2.png";
import AffinityContext from "../../../context/AffinityContext";

const sendWapp = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}

const WhatsAppFAB = () => {
    const { adviserPhone } = useContext(AffinityContext);
    return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "row",textDecoration:"none", height:"70px", width:"250px", cursor:"pointer"  }}>

          <img className="wapp-icon2" src={wapp_icon2} alt="wapp_icon" onClick={
              () => sendWapp('https://wa.me/'  + "+549" + adviserPhone + '?text=¡Buenos%20días!%20Tengo%20una%20consulta:')
          }/>

          <button className="btn-escriba font-face-encode-sans-light"
                  style={{ marginLeft: "-80px", marginTop:"18px"}} onClick={
              () => sendWapp('https://wa.me/' + "+549" + adviserPhone + '?text=¡Buenos%20días!%20Tengo%20una%20consulta:')
          }>
              ¿Hablamos?
          </button>
      </div>
    </React.Fragment>
  );
};

export default WhatsAppFAB;
